var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"notification-bar",class:_vm.type},[_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('span',{staticClass:"close icon icon_delete",on:{"click":_vm.onClose}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }